import { WsBaseRequest } from 'api/ws/WsRequest';
import { API_METHOD_AUTH } from 'api/notificationManager/methods';

export default class AuthRequest extends WsBaseRequest {
  constructor(token: string) {
    super(API_METHOD_AUTH, { t: token });
  }
}
